import React from 'react';

// ── Runmark's mark ───────────────────────────────────────────────────────────
// The platform's own identity, for every surface that is Runmark's rather than
// a tenant's: the control plane, and the shared tenant host before anyone has
// signed in (app.runmark.co.uk cannot know whose portal it is yet, and must
// never guess Parcelink). Drawn rather than shipped as a PNG so it stays
// sharp, themes with currentColor, and costs no request.

export const ACCENT = '#FBBF24'; // amber-400, the same accent the Suggested badge uses

export function RunmarkMark({ className = 'h-7 w-7' }) {
  return (
    <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
      <rect width="32" height="32" rx="9" fill="currentColor" />
      <path
        d="M9 22.5 L9 14.5 A4 4 0 0 1 13 10.5 L17 10.5 A3.5 3.5 0 0 1 17 17.5 L13.5 17.5 L22 22.5"
        stroke="white" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"
      />
      <circle cx="22" cy="22.5" r="2.6" fill={ACCENT} />
    </svg>
  );
}

export function RunmarkWordmark({ className = '' }) {
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <RunmarkMark className="h-7 w-7 text-slate-900" />
      <span className="text-lg font-extrabold tracking-tight text-slate-900">Runmark</span>
    </span>
  );
}

// The same mark as a favicon. index.html bakes Parcelink's logo in for every
// host; a Runmark tab swaps it for this while mounted.
const ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <rect width="32" height="32" rx="9" fill="#0F172A"/>
  <path d="M9 22.5 L9 14.5 A4 4 0 0 1 13 10.5 L17 10.5 A3.5 3.5 0 0 1 17 17.5 L13.5 17.5 L22 22.5"
    stroke="white" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  <circle cx="22" cy="22.5" r="2.6" fill="${ACCENT}"/>
</svg>`;
export const RUNMARK_ICON_HREF = `data:image/svg+xml,${encodeURIComponent(ICON_SVG)}`;
